import useGameButton from './useGameButton.hook';
import { StyledGameButton } from './GameButton.styled';

export default function GameButton({ children, ...props }) {
  const { type } = props;
  const { state, actions } = useGameButton({});
  const customTypes = [
    'primary',
    'secondary',
    'correct',
    'incorrect',
    'listening',
  ];
  if (customTypes.includes(type)) {
    return (
      <StyledGameButton
        {...props}
        type="primary"
        className={`${props.className ?? ''} ${type}`}
      >
        {children}
      </StyledGameButton>
    );
  }

  return <StyledGameButton {...props}>{children}</StyledGameButton>;
}
